import DownloadIcon from '@mui/icons-material/Download';
import { Box, Button, Card, Divider, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const ReferralTable = ({ referralData }) => {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const tableData = Object.keys(referralData).map((key) => {
      return {
        title: key === 'callBacks' ? 'Call Back' : 'Contact',
        count: referralData[key].length,
      };
    });
    tableData.push({
      title: 'Total',
      count: referralData.callBacks.length + referralData.contacts.length,
    });

    setTableData(tableData);
  }, [referralData]);

  return (
    <div className="dark h-full">
      <Card
        variant="outlined"
        sx={{
          boxShadow: 3,
          width: '100%',
          p: '15px',
          background: '#1d2637',
          color: 'white',
          borderRadius: '12px',
          fontFamily: 'Montserrat, serif !important',
          height: '100%',
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          alignSelf={'flex-end'}
          justifyContent="space-between"
          marginBottom={2}
          marginTop={2}
        >
          <Typography
            variant="overline"
            gutterBottom
            sx={{ color: 'white', fontFamily: 'Montserrat, serif !important' }}
          >
            Referral Count
          </Typography>
        </Box>

        <Divider />
        <Box
          display="flex"
          alignItems="center"
          alignSelf={'flex-end'}
          justifyContent="start"
          marginBottom={2}
          marginTop={2}
        >
          <Button
            variant="outlined"
            color="#e62552"
            onClick={() => {}}
            startIcon={<DownloadIcon />}
            sx={{
              fontFamily: 'Montserrat, serif !important',
              visibility: 'hidden',
            }}
          >
            Export Sales Executive-Wise NPS Data
          </Button>
        </Box>
        <div className="">
          {tableData.map((item, index) => (
            <div key={index} className="grid grid-cols-12 bg-[#7e22ce]">
              <div className="col-span-6 border-b-[0.5px] p-2 text-center">
                {item.title}
              </div>
              <div className="col-span-6 border-b-[0.5px] p-2 text-center">
                {item.count}
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

ReferralTable.propTypes = {
  referralData: PropTypes.shape({
    callBacks: PropTypes.array,
    contacts: PropTypes.array,
  }),
};

export default ReferralTable;
